import React from 'react';
import BidCard from "../../newComponents/interestedProviders/bidCard";
import ProposalCard from "../../newComponents/interestedProviders/proposalCard";
import NeedMorePros from "../../newComponents/interestedProviders/needMorePros";
import HiredProvider from "../../newComponents/interestedProviders/hiredProvider";
import IPSkeleton from './IPSkeleton';

const InterestedProviders = ({
    interestedProviders,
    interestedProvidersLoading,
    has_limit,
    project_id,
    provider_hired_id,
    not_yet_api_hitted
}) => {
    const getCurresponding = (data, index) => {
        if (data.bid_amount) {
            return <BidCard
                provider_name={data.provider_name}
                bid_amount={data.bid_amount}
                is_pro_provider={data.is_pro_provider}
                avatar={data.avatar}
                bid_id={data.id}
                insured={data.insured}
                licensed={data.licensed}
                provider_bidded_date={data.provider_bidded_date}
                provider_id={data.provider_id}
                rating_all_together={data.rating_all_together}
                reviews_all_together={data.reviews_all_together}
                years_of_experience={data.years_of_experience}
                down_payment={data.down_payment}
                hours={data.hours}
                remaing_amount={data.remaing_amount}
                total={data.total}
                project_id={data.project_id}
                provider_project_id={data.provider_project_id}
                provider_user_id={data.provider_user_id}
                bid_type={data.bid_type}
                project_number={data.project_number}
                provider_phone_number={data.provider_number}
                is_available={data.is_available}
                provider_deleted={data.provider_deleted}
                provider_email={data.provider_email}
                provider_hired={data.provider_id === provider_hired_id}
            />;
        } else {
            return <ProposalCard
                provider_name={data.provider_name}
                is_pro_provider={data.is_pro_provider}
                avatar={data.avatar}
                rating_all_together={data.rating_all_together}
                reviews_all_together={data.reviews_all_together}
                years_of_experience={data.years_of_experience}
                project_id={project_id}
                provider_id={data.provider_id}
                provider_user_id={data.provider_user_id}
                provider_project_id={data.provider_project_id}
                project_number={data.project_number}
                is_proposal_requested={data.is_proposal_requested}
                lead_purchased_id={data.lead_purchased_id}
                provider_phone_number={data.provider_number}
                unavailable_user={data.unavailable_user}
                is_available={data.is_available ?? true}
                provider_deleted={data.provider_deleted}
                provider_email={data.provider_email}
                provider_contacted_date={data.provider_contacted_date}
            />;
        }
    }
    return (
        <div className="ec-inbidding__bidders">
            {interestedProviders && interestedProviders.length > 0 && !has_limit &&
                <NeedMorePros project_id={project_id} />
            }
            {not_yet_api_hitted &&
                <HiredProvider project_id={project_id} interestedProviders={interestedProviders} />
            }
            <div className="row">
                {!interestedProvidersLoading ? (interestedProviders && interestedProviders?.map((data, index) => {
                    return (
                        <div className="col-md-4 mb-4" key={index}>
                            {getCurresponding(data, index)}
                        </div>
                    );
                })) : <IPSkeleton/>
                }
            </div>
            {
                interestedProviders?.length === 0 && !not_yet_api_hitted && 
                <div className="ec-page__wrong d-flex flex-column justify-content-center align-items-center mt-3">
                    <span className="ec-page__error-circle d-flex align-items-center justify-content-center">
                        <span>
                            <img src="./assets/icon/notify-icon-a.svg" alt="" />
                        </span>
                    </span>
                    <h3 className="ec-page__error-text">
                        We have notified the providers.
                    </h3>
                    <p className="text-muted text-center mt-2">
                        When providers express interest in your project, they will appear here. We'll notify you when providers respond.
                    </p>
                </div>
            }
        </div>
    );
}

export default InterestedProviders;